import { render } from "./DownloadAppView.vue?vue&type=template&id=b1ecd3e4&scoped=true"
import script from "./DownloadAppView.vue?vue&type=script&lang=js"
export * from "./DownloadAppView.vue?vue&type=script&lang=js"

import "./DownloadAppView.vue?vue&type=style&index=0&id=b1ecd3e4&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ecd3e4"]])

export default __exports__